import clsx from 'clsx';
import type { ReactNode } from 'react';

/**
 * Design System · StagePill (pílula de etapa, retangular)
 * done = concluída (verde) · now = atual (azul) · todo = pendente (amarelo).
 * Aceita um avatar/elemento à direita (miniface do responsável).
 */

export type StageState = 'done' | 'now' | 'todo';

interface StagePillProps {
  label: string;
  state?: StageState;
  onClick?: () => void;
  /** elemento à direita (ex.: <Avatar size="sm" />). */
  trailing?: ReactNode;
  className?: string;
}

const DOT: Record<StageState, string> = {
  done: 'bg-green',
  now: 'bg-blue',
  todo: 'bg-yellow',
};

export function StagePill({ label, state = 'todo', onClick, trailing, className }: StagePillProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded border text-[11px] font-semibold transition-colors',
        state === 'now'
          ? 'border-blue text-text bg-blue/10'
          : 'border-border bg-panel-2 text-muted hover:text-text hover:border-border-light',
        onClick ? 'cursor-pointer' : 'cursor-default',
        className,
      )}
    >
      <span className={clsx('w-2 h-2 rounded-full', DOT[state])} />
      {label}
      {trailing}
    </button>
  );
}
